export default "__VITE_ASSET__4ad24047__"